import { Injectable } from "@angular/core";
import { EmployeesStateService } from "../state/employees.state.service";

/**
 * @see https://developers.hubspot.com/docs/api-reference/conversations-chat-configuration/chat-widget-sdk
 *
 * In the future we want to use hubspot verification to ensure we see who we are talking to
 *
 * https://developers.hubspot.com/docs/api-reference/conversations-visitor-identification-v3/guide
 */
@Injectable({
  providedIn: "root"
})
export class HubspotService {
  constructor(private $employees: EmployeesStateService) {}

  private executeWhenReady(callback: () => void) {
    if (window.HubSpotConversations) {
      callback();
    } else {
      window.hsConversationsOnReady = [callback, ...(window.hsConversationsOnReady ?? [])];
    }
  }

  public openChat() {
    this.executeWhenReady(() => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.open();
      } else {
        window.location.href = 'mailto:support@mefit.pro';
      }
    });
  }

  setChatVisibility(visible: boolean) {
    // Apply it immediately if HubSpot is ready
    this.executeWhenReady(() => {
      if (visible) {
        window.HubSpotConversations?.widget.load();
      } else {
        window.HubSpotConversations?.widget.remove();
      }
    });
  }

  public refresh() {
    this.executeWhenReady(() => {
      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.refresh();
      }
    });
  }

  /**
   * Load HubSpot widget with visitor identification
   * This should be called when the user is authenticated
   */
  async load() {
    try {
      const tokenResponse = await this.$employees.getHubspotIdentificationToken.call();

      if (tokenResponse) {
        // Set identification email and token before loading the widget
        window.hsConversationsSettings = {
          loadImmediately: false,
          identificationEmail: tokenResponse.identificationEmail,
          identificationToken: tokenResponse.identificationToken
        };

        // Load the widget with identification
        window.HubSpotConversations?.widget.load();

      }
    } catch (error) {
      console.warn('[HubspotService:load] Error loading HubSpot widget with identification:', error);
      // Fallback to loading without identification
      window.HubSpotConversations?.widget.load();
    }
  }
}
